<div class="main-content">

  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--blue">
        <i class="fas fa-boxes-stacked"></i>
      </div>
      <div>
        <h1 class="main-title">Elenco Colli TP</h1>
        <p class="main-subtitle">Consultazione dei colli pianificati, in arrivo, arrivati e usciti e stampa delle DDT</p>
      </div>
    </div>

    <div class="platform-filter" [class.platform-filter--missing]="!warehouseCode">
      <div class="platform-filter-icon">
        <i class="fas fa-warehouse"></i>
      </div>
      <div class="platform-filter-body">
        <div class="platform-filter-label">
          Transit Point <span class="platform-required" title="Filtro obbligatorio">*</span>
        </div>

        <div class="platform-filter-locked" *ngIf="isSingleWarehouse"
             [title]="'TP assegnato: ' + selectedWarehouseName">
          <span class="platform-filter-name">{{ selectedWarehouseName }}</span>
          <i class="fas fa-lock ms-2"></i>
        </div>

        <div class="platform-filter-select" *ngIf="!isSingleWarehouse">
          <app-searchable-select
                  [(ngModel)]="warehouseCode"
                  [options]="warehouseSelectOptions"
                  icon="fas fa-warehouse"
                  searchPlaceholder="Cerca TP..."
                  (valueChange)="onWarehouseChange()">
          </app-searchable-select>
        </div>

        <div class="platform-filter-hint" *ngIf="!warehouseCode">
          Seleziona un TP per avviare la ricerca
        </div>
      </div>
    </div>
  </div>

  <div class="platform-status-bar" role="group" aria-label="Filtro stato transito TP">
    <span class="platform-status-bar-label">Stato</span>
    <button type="button" class="platform-status-btn"
            *ngFor="let opt of platformStatusOptions"
            [class.active]="isStatusFilterActive(opt.value)"
            [ngClass]="{
              'platform-status-btn--arriving': opt.value === 'ARRIVING',
              'platform-status-btn--arrived': opt.value === 'ARRIVED',
              'platform-status-btn--closed': opt.value === 'CLOSED',
              'platform-status-btn--delivered': opt.value === 'DELIVERED',
              'platform-status-btn--delivered-no-outcome': opt.value === 'DELIVERED_NO_OUTCOME'
            }"
            (click)="toggleStatusFilter(opt.value)"
            [matTooltip]="opt.label">
      <i class="fas" [ngClass]="opt.icon"></i>
      {{ opt.label }}
      <i class="fas fa-check ms-1" *ngIf="isStatusFilterActive(opt.value)"></i>
    </button>

    <div class="platform-days-filter"
         matTooltip="Data affido: da oggi fino a N giorni indietro (0 = solo oggi, max {{ LAST_DAYS_MAX }})"
         matTooltipPosition="above">
      <i class="fas fa-calendar-day"></i>
      <span>negli ultimi</span>
      <input type="number"
             class="platform-days-input"
             min="0"
             [max]="LAST_DAYS_MAX"
             step="1"
             [(ngModel)]="lastDaysBack"
             (change)="onLastDaysBackChange()"
             (keydown.enter)="onLastDaysBackChange()"
             aria-label="Numero di giorni indietro">
      <span>gg</span>
    </div>
  </div>

  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri e Azioni</h3>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-primary-subtle text-primary filters-active-badge" *ngIf="hasActiveFilters()">
            <i class="fas fa-sliders-h me-1"></i> Filtri attivi
          </span>
          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="showFilters = !showFilters"
                  [title]="showFilters ? 'Comprimi' : 'Espandi'">
            <i class="fas" [ngClass]="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body" *ngIf="showFilters">

      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Codice Collo</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-box filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchParcelCode" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codice collo...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice Bolla</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-barcode filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchParcelWaybillCode" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codice bolla...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codici DDT</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-file-lines filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchDDTCodes" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codici DDT...">
          </div>
        </div>

        <div class="col-md-3" *ngIf="filteredClients.length > 1">
          <label class="form-label">Clienti</label>
          <app-searchable-select
                  [(ngModel)]="selectedClients"
                  [options]="clientSelectOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti i clienti"
                  icon="fas fa-users"
                  searchPlaceholder="Cerca cliente..."
                  (valueChange)="onClientsChange()">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Marchi</label>
          <app-searchable-select
                  [(ngModel)]="selectedBrands"
                  [options]="brandSelectOptions"
                  [multiple]="true"
                  [disabled]="brandSelectOptions.length <= 1"
                  allOptionLabel="Tutti i marchi"
                  icon="fas fa-tag"
                  searchPlaceholder="Cerca marchio...">
          </app-searchable-select>
        </div>

        <div class="col-md-3" *ngIf="canSpecial()">
          <label class="form-label">Magazzini Partenza</label>
          <app-searchable-select
                  [(ngModel)]="selectedWarehouseFromCodes"
                  [options]="warehouseFromSelectOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti i magazzini"
                  icon="fas fa-warehouse"
                  searchPlaceholder="Cerca magazzino...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Regioni</label>
          <app-searchable-select
                  [(ngModel)]="selectedRegionCodes"
                  [options]="regionSelectOptions"
                  [multiple]="true"
                  allOptionLabel="Tutte le regioni"
                  icon="fas fa-map"
                  searchPlaceholder="Cerca regione...">
          </app-searchable-select>
        </div>

        <div class="col-md-3" *ngIf="canSpecial()">
          <label class="form-label">Tour</label>
          <app-searchable-select
                  [(ngModel)]="selectedTourGroupNames"
                  [options]="tourGroupSelectOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti i tour"
                  icon="fas fa-route"
                  searchPlaceholder="Cerca tour...">
          </app-searchable-select>
        </div>
        
        <div class="col-md-3">
          <label class="form-label">Bolle Ricevute</label>
          <app-searchable-select
                  [(ngModel)]="ddtReceivedStatus"
                  [options]="ddtReceivedOptions"
                  [multiple]="false"
                  allOptionLabel="Tutte"
                  icon="fas fa-envelope-open"
                  searchPlaceholder="Cerca...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Bolle Stampate</label>
          <app-searchable-select
                  [(ngModel)]="ddtPrintedStatus"
                  [options]="ddtPrintedOptions"
                  [multiple]="false"
                  allOptionLabel="Tutte"
                  icon="fas fa-download"
                  searchPlaceholder="Cerca...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data Stima Consegna Da</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('parcelEstimatedDeliveryDateStart')">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #parcelEstimatedDeliveryDateStartInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('parcelEstimatedDeliveryDateStart')"
                   (click)="openDatePicker('parcelEstimatedDeliveryDateStart')"
                   (focus)="openDatePicker('parcelEstimatedDeliveryDateStart')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelEstimatedDeliveryDateStart', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('parcelEstimatedDeliveryDateStart')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelEstimatedDeliveryDateStart', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('parcelEstimatedDeliveryDateStart')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data Stima Consegna A</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('parcelEstimatedDeliveryDateEnd')">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #parcelEstimatedDeliveryDateEndInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('parcelEstimatedDeliveryDateEnd')"
                   (click)="openDatePicker('parcelEstimatedDeliveryDateEnd')"
                   (focus)="openDatePicker('parcelEstimatedDeliveryDateEnd')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelEstimatedDeliveryDateEnd', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('parcelEstimatedDeliveryDateEnd')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelEstimatedDeliveryDateEnd', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('parcelEstimatedDeliveryDateEnd')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data Arrivo Navetta Da</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('shuttleArrivalDateStart')">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #shuttleArrivalDateStartInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('shuttleArrivalDateStart')"
                   (click)="openDatePicker('shuttleArrivalDateStart')"
                   (focus)="openDatePicker('shuttleArrivalDateStart')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateStart', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('shuttleArrivalDateStart')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateStart', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('shuttleArrivalDateStart')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data Arrivo Navetta A</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('shuttleArrivalDateEnd')">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #shuttleArrivalDateEndInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('shuttleArrivalDateEnd')"
                   (click)="openDatePicker('shuttleArrivalDateEnd')"
                   (focus)="openDatePicker('shuttleArrivalDateEnd')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateEnd', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('shuttleArrivalDateEnd')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('shuttleArrivalDateEnd', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('shuttleArrivalDateEnd')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="dateError">
        <div class="col-12">
          <div class="rt-date-error" role="alert">
            <div class="rt-date-error-icon">
              <i class="fas fa-calendar-xmark"></i>
            </div>
            <div class="rt-date-error-body">
              <div class="rt-date-error-title">Controlla i filtri</div>
              <div class="rt-date-error-text">{{ dateError }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-outline-secondary btn-sm"
                    (click)="resetFilters()" title="Azzera filtri">
              <i class="fas fa-undo me-1"></i> Azzera filtri
            </button>
            <button type="button" class="btn btn-primary btn-sm"
                    (click)="applyFilters()" [disabled]="isLoading" title="Applica filtri">
              <i class="fas" [ngClass]="isLoading ? 'fa-spinner fa-spin me-1' : 'fa-search me-1'"></i>
              Applica filtri
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="summary-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Resoconto</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleReportCollapsed()"
                [title]="isReportCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>
    <div class="card-body" *ngIf="!isReportCollapsed">
      <div class="sm-metrics-grid">

        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--green">
            <i class="fas fa-cube"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
              <ng-container *ngIf="!isLoadingSummaryReport">{{ summaryReport.totalParcels | number }}</ng-container>
            </div>
            <div class="sm-metric-label">Numero Colli</div>
          </div>
        </div>

        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--orange">
            <i class="fas fa-weight"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
              <ng-container *ngIf="!isLoadingSummaryReport">{{ getIntegerPart(summaryReport.totalWeight, '1.3-3') }}<span class="sm-metric-decimals">{{ getDecimalPart(summaryReport.totalWeight, '1.3-3') }}</span></ng-container>
            </div>
            <div class="sm-metric-label">Peso Totale (kg)</div>
          </div>
        </div>

        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--yellow">
            <i class="fas fa-expand-arrows-alt"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
              <ng-container *ngIf="!isLoadingSummaryReport">{{ getIntegerPart(summaryReport.totalVolume, '1.4-4') }}<span class="sm-metric-decimals">{{ getDecimalPart(summaryReport.totalVolume, '1.4-4') }}</span></ng-container>
            </div>
            <div class="sm-metric-label">Volume Totale (m3)</div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div id="parcels-section" class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="header-title">
          <i class="fas fa-file-alt header-icon"></i>
          <h3>Bolle</h3>
        </div>

        <div class="controls-container">

          <div class="filter-input-wrapper quick-search-wrapper me-1">
            <i class="fas fa-magnifying-glass filter-icon"></i>
            <input type="text" class="filter-input"
                   placeholder="Cerca tra i colli filtrati..."
                   [(ngModel)]="globalSearchTerm"
                   (ngModelChange)="onGlobalSearchChange()">
          </div>

          <span class="badge bg-light text-muted me-1" *ngIf="selectedWaybills.size > 0"
                title="Bolle selezionate per la stampa">
            <i class="fas fa-check-square me-1"></i>
            {{ selectedWaybills.size }} {{ selectedWaybills.size === 1 ? 'bolla' : 'bolle' }}
          </span>

          <button type="button" class="header-action-btn me-1"
                  (click)="printSelectedPDF()"
                  [disabled]="isPrintingPDF || selectedWaybills.size === 0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  matTooltip="Stampa DDT bolle selezionate">
            <i class="fas text-danger"
               [class.fa-file-pdf]="!isPrintingPDF"
               [class.fa-spinner]="isPrintingPDF"
               [class.fa-spin]="isPrintingPDF"></i>
          </button>

          <button type="button" class="header-action-btn me-1"
                  (click)="downloadSelectedEdiCsv()"
                  [disabled]="isDownloadingEdi || selectedWaybills.size === 0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  matTooltip="Scarica file EDI bolle selezionate">
            <i class="fas text-success"
               [class.fa-file-csv]="!isDownloadingEdi"
               [class.fa-spinner]="isDownloadingEdi"
               [class.fa-spin]="isDownloadingEdi"></i>
          </button>

          <div class="btn-group btn-group-sm pagination-selector" role="group" aria-label="Elementi per pagina">
            <button type="button" class="btn"
                    *ngFor="let size of pageSizeOptions"
                    [ngClass]="itemsPerPage === size ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(size)"
                    [title]="size + ' elementi per pagina'">
              {{ size }}
            </button>
          </div>

          
          <button type="button" class="header-action-btn me-1"
                  (click)="exportParcelsToExcel()"
                  [disabled]="totalRecords === 0 || isExportingExcel"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  matTooltip="Esporta Excel (tutti i colli filtrati)">
            <i class="fas fa-spinner fa-spin text-success" *ngIf="isExportingExcel"></i>
            <i class="fas fa-file-excel text-success" *ngIf="!isExportingExcel"></i>
          </button>

          <div class="counter-display">
            <span class="badge bg-light text-muted" title="Bolle trovate nella pagina corrente">
              <i class="fas fa-file-alt me-1"></i>
              {{ summaryReport.totalWaybills | number }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-0">

      <div class="table-responsive" *ngIf="!isLoading" (scroll)="closeOpenColumnFilterOnScroll()">
        <table class="table rt-table wm-grouped-table mb-0">
          <thead>
          <tr>
            <th class="rt-select-th text-center">
              <input type="checkbox" class="form-check-input"
                     [checked]="allMatchingSelected || areAllWaybillGroupsSelected()"
                     [disabled]="isSelectingAll || totalRecords === 0"
                     (change)="toggleSelectAll()"
                     title="Seleziona/Deseleziona tutte le bolle dei colli filtrati">
              <i class="fas fa-spinner fa-spin ms-1 text-muted" *ngIf="isSelectingAll"></i>
            </th>
            <th class="rt-expand-th text-center">
              <button
                type="button"
                class="wm-expand-all-btn"
                (click)="$event.stopPropagation(); toggleAllWaybills()"
                [class.has-open]="hasAnyWaybillExpanded()"
                [attr.aria-label]="hasAnyWaybillExpanded()
                  ? 'Comprimi tutte le bolle'
                  : 'Espandi tutte le bolle'"
                [matTooltip]="hasAnyWaybillExpanded()
                  ? 'Comprimi tutte le bolle'
                  : 'Espandi tutte le bolle'">

                <i
                  class="fas"
                  [ngClass]="hasAnyWaybillExpanded()
                    ? 'fa-compress-alt'
                    : 'fa-expand-alt'">
                </i>
              </button>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelOriginalWaybillCode')">
              <div class="wm-th-content">
                Codice Bolla
                <i class="fas" [ngClass]="sortState.active === 'parcelOriginalWaybillCode' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelOriginalWaybillCode')"
                   (click)="toggleColumnFilter('parcelOriginalWaybillCode', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelWaybillCode')">
              <div class="wm-th-content">
                Codice Nuova Bolla
                <i class="fas" [ngClass]="sortState.active === 'parcelWaybillCode' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelWaybillCode')"
                   (click)="toggleColumnFilter('parcelWaybillCode', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('clientName')">
              <div class="wm-th-content">
                Cliente
                <i class="fas" [ngClass]="sortState.active === 'clientName' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('clientName')"
                   (click)="toggleColumnFilter('clientName', $event)"></i>
              </div>
            </th>
            <th scope="col" class="text-center sortable-th" (click)="setSort('parcelTransitStatus')">
              <div class="wm-th-content wm-th-content--center">
                Stato
                <i class="fas" [ngClass]="sortState.active === 'parcelTransitStatus' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelDate')">
              <div class="wm-th-content">
                Data Affido
                <i class="fas" [ngClass]="sortState.active === 'parcelDate' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelDate')"
                   (click)="toggleColumnFilter('parcelDate', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelPickingEventStart')">
              <div class="wm-th-content">
                Data Picking Ingresso
                <i class="fas" [ngClass]="sortState.active === 'parcelPickingEventStart' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelPickingEventStart')"
                   (click)="toggleColumnFilter('parcelPickingEventStart', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelShuttleArrivalDate')">
              <div class="wm-th-content">
                Data Arrivo Navetta
                <i class="fas" [ngClass]="sortState.active === 'parcelShuttleArrivalDate' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelShuttleArrivalDate')"
                   (click)="toggleColumnFilter('parcelShuttleArrivalDate', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelEstimatedDeliveryDate')">
              <div class="wm-th-content">
                Data di Stima Consegna
                <i class="fas" [ngClass]="sortState.active === 'parcelEstimatedDeliveryDate' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelEstimatedDeliveryDate')"
                   (click)="toggleColumnFilter('parcelEstimatedDeliveryDate', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelConsegnaDate')">
              <div class="wm-th-content">
                Data di Consegna
                <i class="fas" [ngClass]="sortState.active === 'parcelConsegnaDate' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelConsegnaDate')"
                   (click)="toggleColumnFilter('parcelConsegnaDate', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('dealerName')">
              <div class="wm-th-content">
                Destinatario
                <i class="fas" [ngClass]="sortState.active === 'dealerName' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('dealerName')"
                   (click)="toggleColumnFilter('dealerName', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('dealerOperatingAddressStreet')">
              <div class="wm-th-content">
                Indirizzo Destinatario
                <i class="fas" [ngClass]="sortState.active === 'dealerOperatingAddressStreet' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('dealerOperatingAddressStreet')"
                   (click)="toggleColumnFilter('dealerOperatingAddressStreet', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('dealerOperatingAddressCity')">
              <div class="wm-th-content">
                Città Destinatario
                <i class="fas" [ngClass]="sortState.active === 'dealerOperatingAddressCity' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('dealerOperatingAddressCity')"
                   (click)="toggleColumnFilter('dealerOperatingAddressCity', $event)"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelRegionName')">
              <div class="wm-th-content">
                Regione
                <i class="fas" [ngClass]="sortState.active === 'parcelRegionName' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelRegionName')"
                   (click)="toggleColumnFilter('parcelRegionName', $event)"></i>
              </div>
            </th>
            <th scope="col" class="text-end sortable-th" (click)="setSort('parcelWeight')">
              <div class="wm-th-content wm-th-content--end">
                Peso (kg)
                <i class="fas" [ngClass]="sortState.active === 'parcelWeight' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
              </div>
            </th>
            <th scope="col" class="text-end sortable-th" (click)="setSort('parcelVolume')">
              <div class="wm-th-content wm-th-content--end">
                Volume (m3)
                <i class="fas" [ngClass]="sortState.active === 'parcelVolume' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
              </div>
            </th>
            <th scope="col" class="text-center">Numero Colli</th>
            <th scope="col" class="text-center sortable-th" (click)="setSort('waybillDdtSentDate')">
              <div class="wm-th-content wm-th-content--center">
                Bolle Ricevute
                <i class="fas" [ngClass]="sortState.active === 'waybillDdtSentDate' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
              </div>
            </th>
            <th scope="col" class="text-center sortable-th" (click)="setSort('waybillDownloadDdtDate')">
              <div class="wm-th-content wm-th-content--center">
                Bolle Scaricate
                <i class="fas" [ngClass]="sortState.active === 'waybillDownloadDdtDate' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSort('parcelTourGroupName')">
              <div class="wm-th-content">
                Tour
                <i class="fas" [ngClass]="sortState.active === 'parcelTourGroupName' ? (sortState.direction === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down') : 'fa-sort'"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('parcelTourGroupName')"
                   (click)="toggleColumnFilter('parcelTourGroupName', $event)"></i>
              </div>
            </th>
            <th scope="col" class="text-center">DDT</th>
            <th scope="col" class="text-center">EDI</th>
          </tr>
          </thead>

          <tbody>
          <tr *ngIf="warehouseCode && !dateError && groupedWaybills.length === 0">
            <td colspan="23" class="text-center text-muted py-5">
              <i class="fas fa-inbox me-2"></i>
              Nessun collo trovato. Modifica i filtri e riprova.
            </td>
          </tr>
          <ng-container *ngFor="let group of groupedWaybills; trackBy: trackByWaybillCode">

            <tr class="rt-row wm-waybill-row"
                [class.selected]="isWaybillGroupSelected(group)"
                [class.expanded]="isWaybillExpanded(group.waybillCode)"
                (click)="toggleWaybillExpand(group.waybillCode)">

              <td class="text-center" (click)="$event.stopPropagation()">
                <input type="checkbox" class="form-check-input"
                       [checked]="isWaybillGroupSelected(group)"
                       (change)="toggleWaybillGroupSelection(group)"
                       [title]="'Seleziona bolla: ' + group.waybillOriginalCode">
              </td>

              <td
                class="text-center wm-expand-cell"
                (click)="$event.stopPropagation()">

                <button
                  type="button"
                  class="wm-expand-btn"
                  [class.is-expanded]="isWaybillExpanded(group.waybillCode)"
                  (click)="toggleWaybillExpand(group.waybillCode)"
                  [attr.aria-label]="isWaybillExpanded(group.waybillCode)
                    ? 'Comprimi colli'
                    : 'Espandi colli'"
                  [matTooltip]="isWaybillExpanded(group.waybillCode)
                    ? 'Comprimi colli'
                    : 'Espandi colli'">

                  <i
                    class="fas"
                    [ngClass]="isWaybillExpanded(group.waybillCode)
                      ? 'fa-chevron-down'
                      : 'fa-chevron-right'">
                  </i>
                </button>
              </td>

              <td class="fw-medium">
                <div class="d-flex align-items-center gap-1">
                  <span class="rt-code rt-strong">{{ group.waybillOriginalCode }}</span>
                  <i class="fas fa-copy copy-icon"
                     (click)="$event.stopPropagation(); copyToClipboard(group.waybillOriginalCode, 'waybill')"
                     [matTooltip]="'Copia codice bolla: ' + group.waybillOriginalCode"></i>
                </div>
              </td>

              <td class="fw-medium">
                <div class="d-flex align-items-center gap-1" *ngIf="group.waybillCode !== group.waybillOriginalCode; else noNewWaybill">
                  <span class="rt-code">{{ group.waybillCode }}</span>
                  <i class="fas fa-copy copy-icon"
                     (click)="$event.stopPropagation(); copyToClipboard(group.waybillCode, 'nuova bolla')"
                     [matTooltip]="'Copia codice nuova bolla: ' + group.waybillCode"></i>
                </div>
                <ng-template #noNewWaybill><span class="text-muted">-</span></ng-template>
              </td>

              <td (click)="$event.stopPropagation()">
                <div class="d-flex align-items-center gap-1" *ngIf="group.clientName; else noClientName">
                  <span>{{ group.clientName }}</span>
                  <i class="fas fa-copy copy-icon"
                     (click)="copyToClipboard(group.clientName, 'cliente')"
                     [matTooltip]="'Copia cliente: ' + group.clientName"></i>
                </div>
                <ng-template #noClientName><span class="text-muted">-</span></ng-template>
              </td>

              <td class="text-center">
                <span [ngClass]="getTransitStatusBadgeClass(group.parcelTransitStatus)">
                  {{ getTransitStatusLabel(group.parcelTransitStatus) }}
                </span>
              </td>

              <td>
                <span class="rt-date" *ngIf="group.parcelDate; else noAffido">{{ group.parcelDate | date:'dd/MM/yy HH:mm' }}</span>
                <ng-template #noAffido><span class="text-muted">-</span></ng-template>
              </td>

              <td>
                <span class="rt-date" *ngIf="group.parcelPickingEventStart; else noPicking">{{ group.parcelPickingEventStart | date:'dd/MM/yy HH:mm' }}</span>
                <ng-template #noPicking><span class="text-muted">-</span></ng-template>
              </td>

              <td>
                <span class="rt-date" *ngIf="group.parcelShuttleArrivalDate; else noShuttle">{{ group.parcelShuttleArrivalDate | date:'dd/MM/yy HH:mm' }}</span>
                <ng-template #noShuttle><span class="text-muted">-</span></ng-template>
              </td>

              <td>
                <span class="rt-date" *ngIf="group.parcelEstimatedDeliveryDate; else noStima">{{ group.parcelEstimatedDeliveryDate | date:'dd/MM/yy HH:mm' }}</span>
                <ng-template #noStima><span class="text-muted">-</span></ng-template>
              </td>

              <td>
                <span class="rt-date" *ngIf="getConsegnaDateValue(group); else noConsegna">{{ getConsegnaDateValue(group) | date:'dd/MM/yy HH:mm' }}</span>
                <ng-template #noConsegna><span class="text-muted">-</span></ng-template>
              </td>

              <td>
                <div class="d-flex align-items-center gap-1" *ngIf="group.dealerName; else noDealerName">
                  <span class="rt-strong">{{ group.dealerName }}</span>
                  <i class="fas fa-copy copy-icon"
                    (click)="$event.stopPropagation(); copyToClipboard(group.dealerName, 'ragione-sociale')"
                    [matTooltip]="'Copia ragione sociale: ' + group.dealerName">
                  </i>
                </div>
                <ng-template #noDealerName>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>

              <td>
                <div class="d-flex align-items-center gap-1"
                    *ngIf="group.dealerOperatingAddressStreet; else noDealerOperatingAddressStreet">
                  <span class="rt-date">{{ group.dealerOperatingAddressStreet }}</span>
                  <i class="fas fa-copy copy-icon"
                    (click)="$event.stopPropagation(); copyToClipboard(group.dealerOperatingAddressStreet, 'indirizzo')"
                    [matTooltip]="'Copia indirizzo: ' + group.dealerOperatingAddressStreet">
                  </i>
                </div>
                <ng-template #noDealerOperatingAddressStreet>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>

              <td>
                <div class="d-flex align-items-center gap-1"
                    *ngIf="group.dealerOperatingAddressCity; else noDealerOperatingAddressCity">
                  <span class="rt-date">{{ group.dealerOperatingAddressCity }}</span>
                  <i class="fas fa-copy copy-icon"
                    (click)="$event.stopPropagation(); copyToClipboard(group.dealerOperatingAddressCity, 'città')"
                    [matTooltip]="'Copia città: ' + group.dealerOperatingAddressCity">
                  </i>
                </div>
                <ng-template #noDealerOperatingAddressCity>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>

              <td>
                <div class="d-flex align-items-center gap-1"
                    *ngIf="group.parcelRegionName; else noParcelRegionName">
                  <span class="rt-date">{{ group.parcelRegionName }}</span>
                  <i class="fas fa-copy copy-icon"
                    (click)="$event.stopPropagation(); copyToClipboard(group.parcelRegionName, 'regione')"
                    [matTooltip]="'Copia regione: ' + group.parcelRegionName">
                  </i>
                </div>
                <ng-template #noParcelRegionName>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>

              <td class="text-end rt-date">{{ group.totalWeight | number:'1.0-2' }}</td>

              <td class="text-end rt-date">{{ group.totalVolume | number:'1.0-4' }}</td>

              <td class="text-center">
                <span class="parcel-count">{{ group.parcelsCount }}</span>
              </td>

              <td class="text-center" (click)="$event.stopPropagation()">
                <button *ngIf="group.waybillDdtSentDate" type="button"
                        class="wm-mail-btn wm-sent"
                        (click)="openDdtSentModal(group, $event)"
                        matTooltip="Dettagli ricezione DDT"
                        matTooltipPosition="above">
                  <i class="fas fa-envelope-open"></i>
                </button>
                <span *ngIf="!group.waybillDdtSentDate"
                      class="wm-mail-btn wm-not-sent"
                      matTooltip="DDT non ancora inviata"
                      matTooltipPosition="above">
                  <i class="fas fa-envelope"></i>
                </span>
              </td>

              <td class="text-center" (click)="$event.stopPropagation()">
                <button *ngIf="group.waybillDownloadDdtDate" type="button"
                        class="wm-download-btn wm-done"
                        (click)="openDdtDownloadModal(group, $event)"
                        matTooltip="Dettagli ultimo download DDT"
                        matTooltipPosition="above">
                  <i class="fas fa-download"></i>
                </button>
                <span *ngIf="!group.waybillDownloadDdtDate"
                      class="wm-download-btn wm-not-done"
                      matTooltip="DDT non ancora scaricata"
                      matTooltipPosition="above">
                  <i class="fas fa-download"></i>
                </span>
              </td>

              <td>
                <span *ngIf="group.parcelTourGroupName; else noTourGroup">{{ group.parcelTourGroupName }}</span>
                <ng-template #noTourGroup><span class="text-muted">-</span></ng-template>
              </td>

              <td class="text-center" (click)="$event.stopPropagation()">
                <button type="button" class="header-action-btn"
                        (click)="printSingleWaybillFromRow(group)"
                        [matTooltip]="'Stampa DDT bolla ' + group.waybillOriginalCode">
                  <i class="fas fa-file-pdf text-danger"></i>
                </button>
              </td>

              <td class="text-center" (click)="$event.stopPropagation()">
                <button type="button" class="header-action-btn"
                        (click)="downloadEdiCsvFromRow(group)"
                        [matTooltip]="'Scarica file EDI bolla ' + group.waybillOriginalCode">
                  <i class="fas fa-file-csv text-success"></i>
                </button>
              </td>
            </tr>

            <ng-container *ngIf="isWaybillExpanded(group.waybillCode)">
              <tr
                class="wm-parcels-subheader"
                [class.is-open]="isWaybillExpanded(group.waybillCode)">
                <td></td>
                <td colspan="22">
                  <table class="table table-sm wm-subtable mb-0">
                    <thead>
                    <tr>
                      <th>Codice Collo</th>
                      <th>Data</th>
                      <th>Descrizione</th>
                      <th class="text-end">Peso (kg)</th>
                      <th class="text-end">Volume (m3)</th>
                      <th class="text-end">Lunghezza (cm)</th>
                      <th class="text-end">Larghezza (cm)</th>
                      <th class="text-end">Altezza (cm)</th>
                      <th>Tipologia</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr class="wm-parcel-subrow" *ngFor="let p of group.parcels">
                        <td class="rt-strong">
                          <div class="d-flex align-items-center gap-1">
                            <span class="rt-code">{{ p.parcelCode }}</span>
                            <i class="fas fa-copy copy-icon"
                               (click)="$event.stopPropagation(); copyToClipboard(p.parcelCode, 'collo')"
                               [matTooltip]="'Copia codice collo: ' + p.parcelCode"></i>
                          </div>
                        </td>
                        <td class="rt-date">{{ p.parcelDate | date:'dd/MM/yy HH:mm' }}</td>
                        <td>
                          <span *ngIf="p.parcelDescription || p.parcelPalletType; else noParcelDescription">
                            {{ p.parcelDescription }}<span *ngIf="p.parcelDescription && p.parcelPalletType"> - </span>{{ p.parcelPalletType }}
                          </span>
                          <ng-template #noParcelDescription><span class="text-muted">-</span></ng-template>
                        </td>
                        <td class="text-end rt-date">{{ p.parcelWeight | number:'1.0-2' }}</td>
                        <td class="text-end rt-date">{{ p.parcelVolume | number:'1.0-4' }}</td>
                        <td class="text-end rt-date">{{ p.parcelLength ?? '-' }}</td>
                        <td class="text-end rt-date">{{ p.parcelWidth ?? '-' }}</td>
                        <td class="text-end rt-date">{{ p.parcelHeight ?? '-' }}</td>
                        <td>
                          <span class="parcel-type-badge"
                                [class.urgent]="p.parcelType === 'U' || p.parcelType === 'URG'"
                                [class.stock]="p.parcelType === 'S' || p.parcelType === 'STK'"
                                [class.unknown]="!p.parcelType || (p.parcelType !== 'U' && p.parcelType !== 'URG' && p.parcelType !== 'S' && p.parcelType !== 'STK')">
                            {{ getParcelTypeLabel(p.parcelType) }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>

          </ng-container>
          </tbody>
        </table>
      </div>

      <div class="wm-col-filter-popover" *ngIf="openColumnFilterKey"
           [style.top]="columnFilterPopoverStyle.top" [style.left]="columnFilterPopoverStyle.left"
           (click)="$event.stopPropagation()">
        <div class="wm-col-filter-section-label">Filtra per valore</div>
        <input type="text" [(ngModel)]="columnValueSearchTerm" placeholder="Cerca valore..." class="wm-col-filter-value-search">
        <div class="wm-col-filter-value-loading" *ngIf="columnDistinctValuesLoading">
          <span class="spinner-border spinner-border-sm"></span> Caricamento valori...
        </div>
        <div class="wm-col-filter-value-list" *ngIf="!columnDistinctValuesLoading">
          <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
            <input type="checkbox" [checked]="areAllVisibleColumnValuesSelected()" (change)="toggleSelectAllColumnValues()">
            Seleziona tutto
          </label>
          <label class="wm-col-filter-value-item" *ngFor="let v of getFilteredColumnDistinctValues()">
            <input type="checkbox" [checked]="isColumnValueChecked(v)" (change)="toggleColumnValue(v)">
            {{ v }}
          </label>
          <div class="wm-col-filter-value-empty" *ngIf="getFilteredColumnDistinctValues().length === 0">Nessun valore trovato</div>
        </div>
        <div class="wm-col-filter-popover-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearColumnFilter(openColumnFilterKey!)">Azzera</button>
          <button type="button" class="btn btn-primary" (click)="applyColumnValueFilter(openColumnFilterKey!)">Applica selezione</button>
        </div>
      </div>

      <div class="pagination-container" *ngIf="!isLoading && totalRecords > 0">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)"
                  [disabled]="currentPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <button *ngFor="let page of getPageNumbers(); trackBy: trackByPageNumber"
                    class="pagination-number"
                    [class.active]="page === currentPage"
                    (click)="onPageChange(page)"
                    [attr.aria-label]="'Pagina ' + page"
                    [title]="'Vai alla pagina ' + page">
              {{ page }}
            </button>
          </div>

          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} di {{ totalRecords }}
          </span>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                  [disabled]="currentPage === getTotalPages()" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
    <span class="visually-hidden">Caricamento...</span>
  </div>
</div>

<div *ngIf="showNotification" class="alert alert-warning d-flex align-items-center justify-content-between"
     style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 300px; z-index: 1050;">
  <div>
    <i class="fas fa-exclamation-triangle me-2"></i>
    <span>{{ notificationMessage }}</span>
  </div>
</div>

<div class="modal fade" tabindex="-1" style="background-color: rgba(0,0,0,0.5);"
     [ngClass]="{ 'show d-block': showDdtSentModal }" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-envelope-open text-success me-2"></i>
          Bolla ricevuta - {{ selectedWaybillGroupForModal?.waybillOriginalCode }}
        </h5>
      </div>
      <div class="modal-body">
        <div class="wm-ddt-modal-status">
          <i class="fas fa-check-circle"></i>
          <span>DDT ricevuta correttamente</span>
        </div>
        <div>
          <div class="wm-ddt-modal-info-label">
            <i class="fas fa-clock"></i> Data e ora ricezione
          </div>
          <div class="wm-ddt-modal-info-value">
            {{ formatDdtDate(selectedWaybillGroupForModal?.waybillDdtSentDate) || 'Non disponibile' }}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-light" (click)="closeDdtSentModal()">Chiudi</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" style="background-color: rgba(0,0,0,0.5);"
     [ngClass]="{ 'show d-block': showDdtDownloadModal }" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-check-circle text-success me-2"></i>
          Bolla scaricata - {{ selectedWaybillGroupForModal?.waybillOriginalCode }}
        </h5>
      </div>
      <div class="modal-body">
        <div class="wm-ddt-modal-status">
          <i class="fas fa-download"></i>
          <span>DDT scaricata correttamente</span>
        </div>
        <div>
          <div class="wm-ddt-modal-info-label">
            <i class="fas fa-clock"></i> Data e ora ultimo download
          </div>
          <div class="wm-ddt-modal-info-value">
            {{ formatDdtDate(selectedWaybillGroupForModal?.waybillDownloadDdtDate) || 'Non disponibile' }}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-light" (click)="closeDdtDownloadModal()">Chiudi</button>
      </div>
    </div>
  </div>
</div>